var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvanced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6661 13.0158C15.666 12.9877 15.666 12.9579 15.6661 12.9264V12.6668H15.67C15.7068 11.2028 16.0432 7.62997 18.3362 5.33694C21.2778 2.39532 26.3256 2.67381 26.3256 2.67381C26.3256 2.67381 26.6041 7.7216 23.6625 10.6632C21.6661 12.6596 18.6998 13.1728 16.9994 13.2965V19.3992C17.3937 18.2103 18.0177 16.9888 19.0029 16.0036C21.9445 13.062 26.9923 13.3405 26.9923 13.3405C26.9923 13.3405 27.2708 18.3883 24.3292 21.3299C22.0362 23.6228 18.4636 23.9593 16.9994 23.9961V29.3335H15.6661V18.6628C14.202 18.6259 10.6292 18.2896 8.33621 15.9966C5.39459 13.0549 5.67307 8.00714 5.67307 8.00714C5.67307 8.00714 10.7209 7.72865 13.6625 10.6703C14.6478 11.6556 15.2719 12.8773 15.6661 14.0664V13.0158ZM24.0632 5.40736L23.5918 4.93595L17.9349 10.5928L18.4063 11.0642L24.0632 5.40736ZM7.93555 10.741L8.40695 10.2696L14.0638 15.9264L13.5924 16.3978L7.93555 10.741ZM24.2585 15.6026L24.7299 16.074L19.073 21.7309L18.6016 21.2595L24.2585 15.6026Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanced);
export default __webpack_public_path__ + "static/media/Advanced.83628ae099a78cff0d67e4141aaffeef.svg";
export { ForwardRef as ReactComponent };